// extracted by mini-css-extract-plugin
export var hideEditor = "_jo-2";
export var infoIcon = "_jo-3";
export var label = "_jo-1";
export var labelContainer = "_jo-0";
export var readonlyText = "_jo-4";